module.exports = __webpack_public_path__ + "static/media/muiecommascara (1).c55d0760.png";